
import React from 'react';
import Navbar from '@/components/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-12 max-w-3xl flex-grow">
        <h1 className="text-3xl font-bold mb-8 text-center">About Krix AI</h1>
        
        <Card className="mb-8">
          <CardContent className="pt-6">
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold mb-2">Our Mission</h2>
                <p>
                  At Krix AI, our mission is to democratize access to the most advanced AI technologies, making them affordable and accessible to everyone. We strive to provide a unified platform that connects users to the most powerful AI models available, empowering them to leverage the full potential of artificial intelligence in their daily workflows.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">Who We Are</h2>
                <p>
                  Founded by a team of AI enthusiasts and industry experts, Krix AI is built on the foundation of innovation, accessibility, and practical AI application. Our team brings together expertise from various domains including machine learning, software development, and user experience design to create a platform that is both powerful and intuitive.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">What We Offer</h2>
                <p className="mb-2">
                  Krix AI provides a unified interface to access multiple state-of-the-art AI models including GPT-4, Claude, and Gemini. Our platform offers:
                </p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Access to multiple AI models through a single, intuitive interface</li>
                  <li>Flexibility to choose the right model for specific tasks</li>
                  <li>Competitive pricing plans for different usage needs</li>
                  <li>Enhanced privacy and security features</li>
                  <li>Regular updates with the latest AI advancements</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">Our Values</h2>
                <p className="mb-2">Our core values guide everything we do at Krix AI:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li><strong>Accessibility:</strong> We make advanced AI capabilities available to users of all backgrounds and budgets.</li>
                  <li><strong>Innovation:</strong> We continuously explore and integrate the latest AI technologies.</li>
                  <li><strong>Transparency:</strong> We maintain open communication about our services, pricing, and data practices.</li>
                  <li><strong>Quality:</strong> We strive for excellence in our platform's performance, reliability, and user experience.</li>
                  <li><strong>Community:</strong> We believe in fostering a collaborative environment where users can share insights and best practices.</li>
                </ul>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">Looking Forward</h2>
                <p>
                  As AI technology continues to evolve at a rapid pace, Krix AI is committed to staying at the forefront of innovation. We are constantly working to enhance our platform, expand our model offerings, and improve the user experience. Our goal is to be your trusted partner in navigating the exciting world of artificial intelligence.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
                <p>
                  Have questions or want to learn more about Krix AI? We'd love to hear from you. Reach out to us at <a href="mailto:hello@krix.app" className="text-primary hover:underline">hello@krix.app</a>.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      
      <footer className="py-8 px-4 border-t">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-xl font-bold gradient-text">Krix AI</p>
              <p className="text-sm text-muted-foreground">© 2025 Krix AI. All rights reserved.</p>
            </div>
            
            <div className="flex flex-wrap justify-center gap-6 md:gap-8">
              <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                About
              </Link>
              <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Contact
              </Link>
              <Link to="/refund" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Refund Policy
              </Link>
              <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
